// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"SuccessIcon_diet_checkmark__1Btks","fill_blue":"SuccessIcon_diet_fill_blue__3cp1r","scale":"SuccessIcon_diet_scale__1qzAx","circle":"SuccessIcon_diet_circle__OQjeH"};